import * as React from "react"
import PropTypes from "prop-types"

import "./footer.scss"

const Footer = ({ siteTitle }) => (
  <footer className="site-footer site-info">
    <small>
      © {new Date().getFullYear()}, {siteTitle} Restaurant
    </small>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
